import { useMemo } from "react";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { useNurseScheduleWeeks } from "../../../../hooks/useNurseScheduleWeeks";
import type { Nurse, TransformedShift } from "../../../../utils/models";
import { buildNurseShifts } from "../../../BedsideHome/hooks";

/** The mobile calendar preview's days: the nurse's shifts and PTO across the loaded weeks, plus those weeks. */
export const useNurseScheduleShifts = (nurse: Nurse) => {
	const { chosenDepartment } = useHospitalData();
	const { weeks, isLoading, isError } = useNurseScheduleWeeks(nurse);
	const shifts = useMemo<TransformedShift[]>(
		// No weeks yet: the preview shows its loading or error state instead of the calendar.
		() => (weeks === undefined ? [] : buildNurseShifts(weeks, nurse, chosenDepartment.dayStart, chosenDepartment.scheduled_shift_delta_minutes)),
		[weeks, nurse, chosenDepartment.dayStart, chosenDepartment.scheduled_shift_delta_minutes],
	);
	return { weeks, shifts, isLoading, isError };
};
